"use client";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useState } from "react";
import { useIntl } from "../../utils/intl";
import TeaserListItem from "./TeaserListItem";
export default function TeaserList(param) {
    var teaserListItems = param.teaserListItems;
    var handleLoadMore = function handleLoadMore() {
        var nextLoadMore = itemsShown + loadMoreIncrement;
        if (nextLoadMore <= maxItems) {
            setItemsShown(nextLoadMore);
        } else {
            setItemsShown(maxItems);
        }
        setHasLoadedMore(true);
    };
    var intl = useIntl();
    var loadMoreIncrement = 6;
    var maxItems = teaserListItems.length;
    var _useState = _slicedToArray(useState(12), 2), itemsShown = _useState[0], setItemsShown = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), hasLoadedMore = _useState1[0], setHasLoadedMore = _useState1[1]; // Track if "Load More" has been clicked
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content-wrapper grid grid-cols-1 md:grid-cols-2 my-20 lg:mt-24 gap-8",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, teaserListItems ? teaserListItems.slice(0, itemsShown).map(function(item, index) {
        var isFirstNewItem = index === itemsShown - loadMoreIncrement;
        return /*#__PURE__*/ React.createElement(TeaserListItem, _extends({}, item, {
            key: index,
            priority: index < 2,
            isFirstNewItem: isFirstNewItem,
            hasLoadedMore: hasLoadedMore
        }));
    }) : null), itemsShown < teaserListItems.length ? /*#__PURE__*/ React.createElement("div", {
        className: "container-content-wrapper my-16 lg:my-28 h-20"
    }, /*#__PURE__*/ React.createElement("button", {
        rel: "next",
        type: "button",
        className: "text-purple mx-auto block text-center cursor-pointer group relative",
        onClick: function() {
            return handleLoadMore();
        },
        "aria-label": intl.formatMessage({
            defaultMessage: "Mehr laden",
            id: "Tyzzqd"
        })
    }, intl.formatMessage({
        defaultMessage: "Mehr laden",
        id: "Tyzzqd"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 block w-[12px] h-[33px] before:h-[33px] before:w-[12px] before:block before:bg-[url('/images/arrow-down.svg')] before:bg-contain mx-auto group-focus:mt-4 group-hover:mt-4 transition-all inset-x-0 duration-300 motion-reduce:transition-none motion-reduce:hover:transform-none motion-reduce:focus:transform-none"
    }))) : /*#__PURE__*/ React.createElement("div", {
        className: "mb-16 lg:mb-28 block h-2 w-full"
    })));
}
